import TextFieldComponent from '@/Inputs/TextFieldComponent';
import { useFormikContext } from 'formik';
import React from 'react';

function CheckoutStepOne(props) {
    const { webAliesError, isUserLogin, userData, rankUpgrad, setFormData } = props;
    const fieldValue = useFormikContext();

    return (
        <div className='flex flex-wrap sm:gap-x-4'>
            {!isUserLogin &&
                <>
                    <TextFieldComponent
                        name="shipping_urname"
                        type='text'
                        label="First name"
                        value={fieldValue?.values?.shipping_urname}
                        onChange={fieldValue?.handleChange}
                        onBlur={(e) => {
                            fieldValue?.handleBlur(e);
                            props?.handleChangeFunction(e, fieldValue?.values)
                        }}
                        errorMessage={fieldValue?.errors?.shipping_urname}
                        divClass={"sm:w-[calc(100%/2-8px)] w-full"}
                    />
                    <TextFieldComponent
                        name='shipping_lastname'
                        type='text'
                        label="Last name"
                        value={fieldValue?.values?.shipping_lastname}
                        onChange={fieldValue?.handleChange}
                        onBlur={(e) => {
                            fieldValue?.handleBlur(e);
                            props?.handleChangeFunction(e, fieldValue?.values)
                        }}
                        errorMessage={fieldValue?.errors?.shipping_lastname}
                        divClass={"sm:w-[calc(100%/2-8px)] w-full"}
                    />
                </>
            }
            {rankUpgrad === 'main_enrollment' && !userData?.webAlias && !isUserLogin &&
                <div className="w-full">
                    <div className='md-3-field xl:mb-[24px] mb-[24px]'>
                        <TextFieldComponent
                            name="webAlias"
                            type={'text'}
                            readOnly={!!userData?.webAlias}
                            label={"Your Web Alias"}
                            value={fieldValue?.values?.webAlias?.replace(/[^\w\s]/gi, '')}
                            onChange={(e) => {
                                fieldValue?.handleChange(e);
                                setFormData({ ...fieldValue?.values, webAlias: e.target.value })
                            }}
                            onBlur={(e) => {
                                fieldValue?.handleBlur(e);
                                props?.handleChangeFunction(e, fieldValue?.values)
                            }}
                            error={!!webAliesError?.isWebAliesError || !!(fieldValue?.errors?.webAlias)}
                            errorMessage={webAliesError?.isWebAliesError || fieldValue?.errors?.webAlias}
                            divClass={`w-full !mb-0  border-clr border-[1px] px-3.5 pt-6 pb-1 rounded-[6px] relative`}
                            classes={`!border-0 !p-0 w-full ${!!userData?.webAlias && '!text-gray-500'}`}
                            inputPar={'static w-full flex'}
                            cstmError={'absolute left-0 top-[calc(100%+24px)] mt-0'}
                        />
                        <span className='mt-1.5 block text-[12px] leading-[1.2]'>{'(You will share this link with others you bring in)'}</span>
                    </div>
                </div>
            }

        </div >
    )

}

export default CheckoutStepOne